"use strict";
import axios from "axios";
import store, { FETCH_LOADING } from "../store";
import { queryUrl } from "@/utils";
import { stochastic, encrypt, decrypt } from "@/utils/crypto";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const prefix = `api`;
let config = {
  baseURL: process.env.baseURL || process.env.apiUrl || `/${prefix}`,
  // timeout: 60 * 1000, // Timeout
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
  withCredentials: true, // Check cross-site Access-Control
};
// token
const _axios = axios.create(config);

_axios.interceptors.request.use(
  async function (config) {
    // encryptType 0 出入参不加密；1 参数不加密，返回加密; 2 参数加密，返回不加密； 3 参数加密，返回加密
    const { needToken = true, encryptType = 0 } = config;
    const { token, authorization } = queryUrl(location.href);
    console.log(`token:`, token);
    console.log(`authorization:`, authorization);
    console.log(`store.state.token:`, store.state.token);
    if (needToken && (token || store.state.token)) {
      config.headers["Blade-Auth"] =
        (token && decodeURIComponent(token)) || store.state.token;
    }
    if (needToken && (authorization || store.state.authorization)) {
      config.headers["authorization"] =
        (authorization && decodeURIComponent(authorization)) ||
        store.state.authorization;
    }
    // 加密请求 追加请求header
    if (encryptType) {
      config.headers["stochastic"] = stochastic;
    }
    if (encryptType === 2 || encryptType === 3) {
      config.data = encrypt(JSON.stringify(config.data));
    }

    console.log(`config.headers:`, config.headers);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  async function (response) {
    return response;
  },
  async function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);
const request = (params) => {
  const id = "Fetch" + new Date().getTime();
  const { fetchList } = store.state;
  fetchList.push(id);
  if (
    Object.prototype.toString.call(params.fetchLoading) === "[object Boolean]"
  ) {
    store.commit({
      type: FETCH_LOADING,
      fetchLoading: params.fetchLoading,
    });
  } else {
    store.commit({
      type: FETCH_LOADING,
      fetchLoading: true,
    });
  }
  return _axios
    .call(this, params)
    .then(function (res) {
      const index = fetchList.indexOf(id);
      fetchList.splice(index, 1);
      const timer = setTimeout(() => {
        clearTimeout(timer);
        if (fetchList.length === 0) {
          store.commit({
            type: FETCH_LOADING,
            fetchLoading: false,
          });
        }
      }, 300);
      if (res.data.encrypt) {
        let data = JSON.parse(decrypt(res.data.data));
        return { ...res.data, data };
      }
      return res.data;
    })
    .catch((e) => {
      fetchList.length = 0;
      store.commit({
        type: FETCH_LOADING,
        fetchLoading: false,
      });
      return Promise.reject(e);
    });
};
export default {
  install: (app) => {
    app.config.globalProperties.axios = request;
    app.provide("axios", request);
  },
};

export { request, prefix };
